export enum APP_ENV {
  LOCAL = 'local',
  REVIEW = 'review',
  INT = 'int',
  STAGE = 'stage',
  PROD = 'production',
}

export enum SB_ENV {
  INT = 'int',
  PROD = 'production',
}
